module.exports = __webpack_public_path__ + "static/media/logo.bbc84a05.svg";